import React from 'react';
import { Navigate } from 'react-router-dom';

const PublicRoute = ({ children }) => {
    const isLoggedIn = localStorage.getItem('token');

    // If I am ALREADY logged in, send me to Home
    if (isLoggedIn) {
        return <Navigate to="/home" replace />;
    }

    // Otherwise, let me see the Login page
    return children;
};

export default PublicRoute;